import { ConnectionStatus, Network } from '@capacitor/network';
import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, distinctUntilChanged, fromEvent, map, mapTo, merge, startWith } from 'rxjs';
import { debounceLoading } from '@shared/helpers/async.helpers';


@Injectable({ providedIn: 'root' })
export class NetworkStatusService {

    private networkStatus = new BehaviorSubject<ConnectionStatus>({ connected: false, connectionType: 'unknown' });
    readonly networkStatus$ = this.networkStatus.asObservable();



    private webSocketStatus = new BehaviorSubject<boolean>(false);
    readonly webSocketStatus$ = this.webSocketStatus.asObservable();

    readonly connectionIssues$ = combineLatest([
        this.networkStatus$,
        this.webSocketStatus$
    ]).pipe(
        map(([networkStatus, webSocketStatus]) => {
            this.networkIssuesSubject.next(!networkStatus.connected || !webSocketStatus);
            return !networkStatus.connected || !webSocketStatus;
        }),
        debounceLoading()
    );

    networkIssuesSubject = new BehaviorSubject<boolean>(false);

    private connected$ = new BehaviorSubject<boolean>(typeof navigator !== 'undefined' ? navigator.onLine : true);
    readonly online$ = this.connected$.asObservable().pipe(distinctUntilChanged());


    constructor() {
        this.initializeNetworkEvents();
        merge(
            fromEvent(window, 'online').pipe(map(() => true)),
            fromEvent(window, 'offline').pipe(map(() => false))
        ).subscribe(v => this.connected$.next(v));
    }

    get isOnlineSync(): boolean {
        return this.connected$.getValue();
    }

    setWebSocketStatus(connected: boolean) {
        this.webSocketStatus.next(connected);
    }

    private async initializeNetworkEvents() {
        const status = await Network.getStatus();
        this.networkStatus.next(status);

        Network.addListener('networkStatusChange', (status) => {
            this.networkStatus.next(status);
        });
    }


}
